import React, { useState } from "react";
import { useForm } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../styles/Admin.css";
import ImageUploader from "../../../../components/admin/ImageUploader";

const FormEditBurger = ({ selectedBurger, handleEdit }) => {
  const [imageUrl, setImageUrl] = useState(selectedBurger.photo_url || null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      type_description: selectedBurger.type_description || "",
      type_large_description: selectedBurger.type_large_description || "",
      side_fries: !!selectedBurger.side_fries,
      background_color: selectedBurger.background_color || "#198754",
    },
  });

  const onSubmit = (data) => {
    handleEdit({
      ...selectedBurger,
      type_description: data.type_description,
      type_large_description: data.type_large_description,
      side_fries: data.side_fries ? 1 : 0,
      background_color: data.background_color,
      photo_url: imageUrl,
    });
  };

  const handleImageUploaded = (url) => {
    setImageUrl(url);
  };

  return (
    <div className="container">
      <div className="burger-form-container mx-auto">
        <h3 className="text-center fw-bold products-title ">
          Editar Hamburguesa
        </h3>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3">
            <label className="form-label">Descripción de la hamburguesa</label>
            <input
              type="text"
              className={`form-control ${
                errors.type_description ? "is-invalid" : ""
              }`}
              {...register("type_description", {
                required: "Este campo es obligatorio",
              })}
              placeholder="Ej: Clásica con cheddar"
            />
            <div className="invalid-feedback" style={{ minHeight: "20px" }}>
              {errors.type_description?.message || ""}
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">Descripción detallada</label>
            <textarea
              className={`form-control ${
                errors.type_large_description ? "is-invalid" : ""
              }`}
              rows="4"
              {...register("type_large_description", {
                required: "Este campo es obligatorio",
              })}
              placeholder="Ej: Deliciosa hamburguesa con carne 100% de res, queso cheddar derretido..."
            />
            <div className="invalid-feedback" style={{ minHeight: "20px" }}>
              {errors.type_large_description?.message || ""}
            </div>
          </div>

          <div className="form-check mb-3">
            <input
              type="checkbox"
              className="form-check-input"
              id="side_fries"
              {...register("side_fries")}
            />
            <label className="form-check-label" htmlFor="side_fries">
              ¿Incluye papas fritas?
            </label>
          </div>

          <div className="mb-3">
            <label className="form-label">Color de fondo del botón</label>
            <input
              type="color"
              className={`form-control form-control-color ${
                errors.background_color ? "is-invalid" : ""
              }`}
              {...register("background_color", {
                required: "Selecciona un color de fondo",
              })}
              title="Elige el color de fondo para el botón de esta hamburguesa"
            />
            <div className="invalid-feedback" style={{ minHeight: "20px" }}>
              {errors.background_color?.message || ""}
            </div>
          </div>

          <ImageUploader
            currentImageUrl={selectedBurger.photo_url}
            onImageUploaded={handleImageUploaded}
          />

          <button type="submit" className="btn products-btn  w-100">
            Guardar cambios
          </button>
        </form>
      </div>
    </div>
  );
};

export default FormEditBurger;
